import { Loader, Text } from '@gasbuddy/react-components';
import { useWindowSize } from '@gasbuddy/react-hooks';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { OUTDATED_PRICE_DISPLAY } from '../../constants';
import ReportedBy from '../ReportedBy';
import styles from './StationDisplayPrice.module.css';

const cx = classnames.bind(styles);

export default function StationDisplayPrice({ asCard, bordered, formattedPrice, isCash, isLoadingPrices, postedTime, reportedBy }) {
  const { t } = useTranslation('price');
  const { mobile: isMobileView } = useWindowSize();

  const showLoader = isLoadingPrices && formattedPrice === OUTDATED_PRICE_DISPLAY;

  return (
    <div className={cx('priceContainer', { asCard: isMobileView || asCard })}>
      <div className={cx('borderContainer', { bordered })}>
        <Text className={cx('price')} size="xl">
          {showLoader ? <Loader size="sm" /> : formattedPrice}
        </Text>

        {reportedBy && (
          <Fragment>
            <ReportedBy
              username={reportedBy}
              time={postedTime}
            />
            {isCash && (
              <Text uppercase className={cx('cashTag')}>
                {t('cash', { ns: 'price' })}
              </Text>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
}

StationDisplayPrice.propTypes = {
  asCard: PropTypes.bool,
  bordered: PropTypes.bool,
  formattedPrice: PropTypes.string,
  isCash: PropTypes.bool,
  isLoadingPrices: PropTypes.bool,
  postedTime: PropTypes.string,
  reportedBy: PropTypes.string,
};

StationDisplayPrice.defaultProps = {
  asCard: false,
  bordered: false,
  formattedPrice: OUTDATED_PRICE_DISPLAY,
  isCash: false,
  isLoadingPrices: false,
  postedTime: undefined,
  reportedBy: undefined,
};
